<template>
    <div class="button_parts_count_up">
        <button @click="countUp">カウントアップ</button>
        <p>数字：{{count}}</p>
    </div>
</template>

<script>
export default {
    data(){
        return{
            count: 0
        }
    },
    methods:{
        countUp(){
            this.count = this.count + 1
        }
    }

}
</script>
